import React from "react";
import "./Upcoming.scss";
import { UpcomingImg as Upcomingimage } from "assets/images";
import { Link } from "react-router-dom";

const Upcoming = ({ title, description, linkTo = "/", linkText = "Go Home" }) => {
  return (
    <div className="upcoming_page spacing">
      <img src={Upcomingimage} alt="Upcoming Feature" />
      <h4>{title || "Coming Soon!"}</h4>
      <p>{description || "This feature is currently under development. Stay tuned!"}</p>
      <Link className="button" to={linkTo}>
        {linkText}
      </Link>
    </div>
  );
};

export default Upcoming;
